"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.documentAddEventListener = documentAddEventListener;
exports.eventListenerOpts = eventListenerOpts;
exports.windowAddEventListener = windowAddEventListener;
var _runtime = require("../constants/runtime");
/*
 * See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#safely_detecting_option_support
 */
let passiveSupported = false;
let signalSupported = false;
try {
  const options = {
    get passive() {
      // this function will be called when the browser attempts to access the passive property
      passiveSupported = true;
      return false;
    },
    get signal() {
      signalSupported = true;
      return false;
    }
  };
  _runtime.globalScope.addEventListener('test', null, options);
  _runtime.globalScope.removeEventListener('test', null, options);
} catch (err) {}
function eventListenerOpts(useCapture, abortSignal) {
  return passiveSupported || signalSupported ? {
    capture: !!useCapture,
    passive: passiveSupported,
    // passive defaults to false
    signal: abortSignal
  } : !!useCapture; // mainly just IE11 doesn't support third param options under EventTarget API
}

/** Do not use this within the worker context. */
function windowAddEventListener(event, listener, capture = false, abortSignal) {
  window.addEventListener(event, listener, eventListenerOpts(capture, abortSignal));
}
/** Do not use this within the worker context. */
function documentAddEventListener(event, listener, capture = false, abortSignal) {
  document.addEventListener(event, listener, eventListenerOpts(capture, abortSignal));
}